<template>
  <div style="padding-top: 1rem">
    <!--<navTitle title="个人资料"></navTitle>-->
    <navTitle
      :title="
        $router.app._route.query.ti ? $router.app._route.query.ti : 'User profile'
      "
      path="/user"
    ></navTitle>

    <div class="personal-data">
      <div class="wrapper">
        <div class="title">Manage my account</div>
        <!--<div class="wrapList">
          <div
            class="item acea-row row-between-wrapper"
            :class="item.uid === userInfo.uid ? 'on' : ''"
            v-for="(item, index) in switchUserInfo"
            :key="index"
          >
            <div class="picTxt acea-row row-between-wrapper">
              <div class="pictrue">
                <VueCoreImageUpload
                  class="btn btn-primary"
                  :crop="false"
                  compress="80"
                  @imageuploaded="imageuploaded"
                  :headers="headers"
                  :max-file-size="5242880"
                  :credentials="false"
                  inputAccept="image/*"
                  inputOfFile="file"
                  :url="url"
                  ref="upImg"
                  v-if="item.uid === userInfo.uid"
                >
                  <div class="pictrue">
                    <img :src="item.avatar" />
                  </div>
                </VueCoreImageUpload>
                <div class="pictrue" v-else>
                  <img :src="item.avatar" />
                </div>
                <img
                  src="@assets/images/alter.png"
                  class="alter"
                  v-if="item.uid === userInfo.uid"
                />
              </div>
              <div class="text">
                <div class="name line1">{{ item.nickname }}</div>
                <div class="phone">bind phone:{{ item.phone }}</div>
              </div>
            </div>
            <div
              class="currentBnt acea-row row-center-wrapper font-color-red"
              v-if="item.uid === userInfo.uid"
            >
              Activation
            </div>
            <div
              class="bnt font-color-red acea-row row-center-wrapper"
              v-else
              @click="switchAccounts(index)"
            >
              Use
            </div>
          </div>
        </div>-->
      </div>
      <div class="list">
        <div class="item acea-row row-between-wrapper">
          <div>nickName</div>
          <div class="input">
            <input type="text" v-model="userInfo.nickname" />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>ID</div>
          <div class="input acea-row row-between-wrapper">
            <input type="text" :value="userInfo.uid" disabled class="id" /><span
              class="iconfont icon-suozi"
            ></span>
          </div>
        </div>
        <div v-if="!userInfo.phone">
          <router-link
            :to="'/user/binding'"
            class="item acea-row row-between-wrapper"
          >
            <div>bind phone</div>
            <div class="input">
              Click bind phone number<span class="iconfont icon-xiangyou"></span>
            </div>
          </router-link>
        </div>
        <div
          class="item acea-row row-between-wrapper"
          v-else-if="userInfo.phone"
        >
          <div>Phone</div>
          <div class="input acea-row row-between-wrapper">
            <div class="input acea-row row-between-wrapper">
              <input
                type="text"
                :value="userInfo.phone"
                disabled
                class="id"
              /><span class="iconfont icon-suozi"></span>
            </div>
          </div>
        </div>
        <div v-if="userInfo.phone && userInfo.user_type === 'h5'">
          <router-link
            :to="'/change_password'"
            class="item acea-row row-between-wrapper"
          >
            <div>Password</div>
            <div class="input">
              Click change password<span class="iconfont icon-xiangyou"></span>
            </div>
          </router-link>
        </div>
      </div>
      <div class="modifyBnt bg-color-red" @click="submit">Save the change</div>
      <div
        class="logOut cart-color acea-row row-center-wrapper"
        @click="logout"
        v-if="!isWeixin"
      >
        Log out
      </div>
      <div class="logOut cart-color acea-row row-center-wrapper" style="color: #00C3F9 !important;border: 1px solid #00C3F9 !important;margin-top: -15px;"
              @click="googleBind">
        Google Bind
      </div>

      <div id="forPop" v-if="is_bind" @click="bgClose"></div>
      <div v-if="is_bind" class="google-bind">
        <div v-if="show_google_bind" style="text-align: center;margin-top: 50px" class="row-wrap">
          <p>
            <svg style="font-size: 1.2rem" t="1634639923210" class="icon" viewBox="0 0 1024 1024"
                 version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2447" width="200" height="200">
              <path d="M950.272 153.088c-13.312-10.752-30.208-16.896-48.128-16.896h-5.12c-1.024 0-12.288 0.512-30.208 0.512-29.696 0-87.04-1.536-141.824-13.824-70.656-15.36-152.064-86.016-175.616-100.352-11.776-7.168-25.6-10.752-39.424-10.752s-27.648 3.584-39.424 10.752c-3.072 1.536-88.064 81.92-171.52 100.352-54.784 11.776-113.152 13.824-142.848 13.824-17.92 0-29.184-0.512-30.208-0.512h-4.608c-17.92 0-35.328 6.144-48.64 16.896-14.336 11.776-22.528 28.16-22.528 45.568v156.16c0 578.048 428.544 652.8 446.976 655.36 4.096 0.512 8.192 1.024 12.288 1.024s8.192-0.512 12.288-1.024c18.432-3.072 450.048-77.312 450.048-655.36V198.656c1.024-17.408-7.168-33.792-21.504-45.568z m-48.128 201.728c0 532.48-391.68 593.92-391.68 593.92s-388.608-61.44-388.608-593.92V198.656s13.312 1.024 35.328 1.024c37.376 0 99.84-2.56 159.744-15.36C414.72 162.816 510.464 75.264 510.464 75.264s99.84 87.552 198.144 109.056c59.904 12.8 121.344 15.36 158.72 15.36 21.504 0 35.328-1.024 35.328-1.024v156.16h-0.512zM730.624 322.56l-274.432 242.176-136.192-120.32c-16.896-14.848-44.544-14.848-61.44 0-16.896 14.848-16.896 38.912 0 54.272l158.72 140.288c2.048 3.072 4.096 5.632 6.656 8.192 8.704 7.68 20.48 11.264 31.744 11.264 11.264 0.512 23.04-3.584 31.744-11.264 2.56-2.56 5.12-5.12 7.168-8.192l296.96-262.144c16.896-14.848 16.896-38.912 0-54.272-16.384-14.848-44.032-14.848-60.928 0z"
                    fill="#00C88D" p-id="2448"></path>
            </svg>
          </p>
          <p><b><br>Google Authenticator</b><br><br></p>
          <div class="google-authenticator-btn bg-color-blue" @click="bgClose">Close</div>
        </div>
        <div v-else class="row-wrap">
          <div class="row">
            <div class="row-name">Phone</div>
            <input class="input" v-model="google.phone" readonly/>
          </div>
          <div class="row">
            <div class="row-name">Secret</div>
            <input class="input" v-model="google.secret" readonly/>
          </div>
          <div style="background-color: #fff;">
            <div style="float: left;padding: 5px 15px;width:140px;">
              <img width="100%" :src="google.img_url">
            </div>
            <div style="width: 70%;margin-left: 102px;padding-top: 5px">
              <p>Scan the code or enter secret to get the code verification binding</p>
            </div>
          </div>
          <div class="row">
            <div class="row-name">Code</div>
            <input class="input" placeholder="google verify code" v-model="google.code"/>
          </div>
          <div class="google-authenticator-btn bg-color-blue" @click="verifyBind">
            <div>
              <div style="float: left;">
                <svg style="font-size: .6rem;position:absolute;margin-top: 6px;margin-left: 60px"
                     t="1634613698906" class="icon" viewBox="0 0 1024 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="5337" width="200" height="200">
                  <path d="M0 511.5776C0 794.112 229.0176 1023.1552 511.5776 1023.1552c282.5472 0 511.5776-229.0304 511.5776-511.5776C1023.1552 229.0176 794.112 0 511.5776 0 229.0176 0 0 229.0176 0 511.5776z"
                        fill="#656565" p-id="5338"></path>
                  <path d="M766.848 805.3376a38.5664 38.5664 0 1 0 38.5408-38.5792c-21.5808 0.512-38.5536 17.472-38.5536 38.5792z"
                        fill="#777777" p-id="5339"></path>
                  <path d="M671.7184 512.2688v-0.512c0-88.4352-71.9616-159.8976-160.4096-159.8976-88.4352 0-159.36 71.9744-159.36 159.8976a159.424 159.424 0 0 0 21.9648 81.024l0.4096 0.6912 1.4464 2.3936 0.768 1.2416 1.1776 1.8304 1.0752 1.6384c0.32 0.4736 0.64 0.96 0.9856 1.4336 0.3328 0.4736 0.8576 1.2544 1.2416 1.8944l0.8576 1.1776 1.4848 2.048 0.768 1.0112 1.6128 2.112 0.7424 0.9472 1.7024 2.0864 0.7936 0.96c0.5632 0.6784 1.1264 1.3568 1.7024 2.0096l0.9344 1.0624c0.5504 0.6272 1.088 1.2544 1.6512 1.8688l1.152 1.2416 1.5104 1.6128a62.72 62.72 0 0 0 1.792 1.8432l0.9472 0.96L594.56 820.224a319.9744 319.9744 0 0 0 236.544-307.9424H671.7184z"
                        fill="#4D4D4D" p-id="5340"></path>
                  <path d="M511.8208 831.5264a319.424 319.424 0 0 1-319.744-319.7824c0-175.808 141.8752-319.744 318.72-319.744a320.384 320.384 0 0 1 225.728 92.5824l135.7568-135.7696A511.744 511.744 0 0 0 511.5776 0C230.9376 0 0 230.9376 0 511.5776c0 280.64 230.9376 511.5776 511.5776 511.5776 80.0896 0 159.0656-18.816 230.5536-54.912L594.624 820.7232c-27.008 7.1936-54.848 10.8288-82.8032 10.816z"
                        fill="#999999" p-id="5341"></path>
                  <path d="M179.6736 805.3376a38.5664 38.5664 0 1 0 38.5664-38.5792c-21.5936 0.512-38.5664 17.472-38.5664 38.5792zM57.856 511.744a38.5536 38.5536 0 1 0 38.5536-38.5664c-21.5808 0.512-38.5536 17.472-38.5536 38.5664z m121.8176-293.568a38.5664 38.5664 0 1 0 77.1328 0.1024 38.5664 38.5664 0 0 0-77.1328-0.1024z m293.5936-121.856a38.5664 38.5664 0 1 0 38.5664-38.5536c-21.5936 0.512-38.5664 17.472-38.5664 38.5536z m0 830.848a38.5664 38.5664 0 1 0 77.1328 0.0128 38.5664 38.5664 0 0 0-77.1328-0.0256z"
                        fill="#C1C1C1" p-id="5342"></path>
                  <path d="M933.4144 559.5776H517.4912a47.808 47.808 0 0 1 0-95.6288h415.9232a47.808 47.808 0 1 1 0 95.616z"
                        fill="#AFAFAF" p-id="5343"></path>
                </svg>
              </div>
              <b>Verify Bind</b>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { trim, VUE_APP_API_URL, isWeixin } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";
import { postUserEdit, getLogout, switchH5Login, getUser,getGoogleSecret, googleAuthBind } from "@api/user";
import { clearAuthStatus } from "@libs/wechat";
import navTitle from "@components/navTitle.vue";
import cookie from "@utils/store/cookie";
import store from "@/store";
import dayjs from "dayjs";

export default {
  name: "PersonalData",
  components: {
    // VueCoreImageUpload,
    navTitle
  },
  data: function() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      avatar: "",
      isWeixin: false,
      currentAccounts: 0,
      switchUserInfo: [],
      userIndex: 0,
      is_bind: false,
      show_google_bind: false,
      google: {
        phone: '',
        secret: '',
        code: '',
        img_url: 'loading.gif'
      }
    };
  },
  watch: {
    $route(n) {
      if (n.name === "PersonalData") this.$store.dispatch("USERINFO", true);
    }
  },
  computed: mapGetters(["userInfo"]),
  mounted: function() {
    this.avatar = this.userInfo.avatar;
    this.isWeixin = isWeixin();
    this.getUserInfo();
  },
  methods: {
    switchAccounts: function(index) {
      let that = this;
      this.userIndex = index;
      let userInfo = this.switchUserInfo[this.userIndex];
      if (this.switchUserInfo.length <= 1) return true;
      if (userInfo === undefined)
        return this.$dialog.toast({ mes: "The switched account does not exist" });
      alert(userInfo.user_type);
      if (userInfo.user_type === "h5" || userInfo.user_type === "facebook") {
        switchH5Login()
          .then(({ data }) => {
            // console.log('switchH5',data)
            that.$dialog.loading.close();
            const expires_time = dayjs(data.expires_time);
            store.commit("LOGIN", data.token, expires_time);
            that.$emit("changeswitch", false);
            location.reload();
          })
          .catch(err => {
            that.$dialog.loading.close();
            return that.$dialog.toast({ mes: err });
          });
      } else {
        cookie.set("loginType", "wechat", 60);
        this.$dialog.loading.close();
        this.$store.commit("LOGOUT");
        clearAuthStatus();
        this.$emit("changeswitch", false);
        location.reload();
      }
    },
    getUserInfo: function() {
      let that = this;
      getUser().then(res => {
        let switchUserInfo = res.data.switchUserInfo;
        for (let i = 0; i < switchUserInfo.length; i++) {
          if (switchUserInfo[i].uid == that.userInfo.uid) that.userIndex = i;
          if (
            !that.isWeixin &&
            switchUserInfo[i].user_type != "h5" &&
            switchUserInfo[i].phone === ""
          )
            switchUserInfo.splice(i, 1);
        }
        that.$set(this, "switchUserInfo", switchUserInfo);
      });
    },
    imageuploaded(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "Upload picture failed");
      if (this.switchUserInfo[this.userIndex] === undefined) return;
      this.$set(this.switchUserInfo[this.userIndex], "avatar", res.data.url);
    },

    submit: function() {
      let userInfo = this.switchUserInfo[this.userIndex];
      postUserEdit({
        nickname: trim(this.userInfo.nickname),
        avatar: userInfo.avatar || ""
      }).then(
        res => {
          this.$store.dispatch("USERINFO", true);
          this.$dialog.success(res.msg);
          this.$router.go(-1);
        },
        error => {
          this.$dialog.error(error.msg);
        }
      );
    },
    logout: function() {

      this.$dialog.confirm({
        mes: "Confirm logout?",
        title: "Logout",
        opts: [
          {
            txt: "Cancel",
            color: false,
            callback: () => {

            }
          },
          {
            txt: "Confirm",
            color: "#DD001B",
            callback: () => {
              getLogout()
                .then(res => {
                  this.$store.commit("LOGOUT");
                  clearAuthStatus();
                  location.href = location.origin;
                  // console.log(res);
                })
                .catch(err => {
                  // console.log(err);
                });
            }
          }
        ]
      });
      // this.$dialog.confirm({
      //   mes: "Confirm logout?",
      //   opts: () => {
      //     getLogout()
      //       .then(res => {
      //         this.$store.commit("LOGOUT");
      //         clearAuthStatus();
      //         location.href = location.origin;
      //         // console.log(res);
      //       })
      //       .catch(err => {
      //         // console.log(err);
      //       });
      //   }
      // });
    },
    googleBind: function () {
      let that = this
      that.is_bind = !that.is_bind
      this.google.phone = this.userInfo.phone
      if (that.google.secret === '') {
        getGoogleSecret().then(res => {
          // console.log(res)
          if (res.data.is_bind === 1) {
            that.show_google_bind = true
          } else {
            that.google.img_url = res.data.qr_code
            that.google.secret = res.data.secret
          }
        })
      }
    },
    verifyBind: function () {
      let that = this
      if (this.google.code === '') {
        return this.$dialog.toast({mes: "Please fill in the google verify code"});
      }
      let data = {phone: this.google.phone, secret: this.google.secret, code: this.google.code}
      googleAuthBind(data).then(res => {
        that.show_google_bind = true
        // that.is_bind = false
        return that.$dialog.toast({mes: res.msg});
      }).catch(res => {
        return that.$dialog.toast({mes: res.msg});
      })
      // console.log(this.google)
    },
    bgClose: function () {
      // this.google.secret = ''
      // this.google.img_url = 'loading.gif'
      this.is_bind = false
    }
  }
};
</script>
<style scoped>
  .row {
    width: 100%;
    padding: 0 0.27rem;
    box-sizing: border-box;
    background: #fff;
    height: 0.75rem;
    line-height: 0.75rem;
    display: flex;
    position: relative;
  }

  .row::after {
    content: "";
    position: absolute;
    width: calc(100% - 0.27rem - 0.27rem);
    bottom: 0px;
    left: 0;
    right: 0;
    margin: 0 auto;
    height: 1px;
    background: #eee;
  }

  .row .row-name {
    width: 2.5rem;
  }

  .row .input {
    flex: 1;
    display: block;
    height: 0.75rem;
    line-height: 0.75rem;
    box-sizing: border-box;
    padding-left: 0.15rem;
    border: none;
    background: #fff;
  }

  .row .select {
    flex: 1;
    display: block;
    height: 0.75rem;
    line-height: 0.75rem;
    box-sizing: border-box;
    padding-left: 0.15rem;
    border: none;
    background: #fff;
  }
  .google-authenticator-btn {
    display: block;
    width: 5.5rem;
    height: 0.86rem;
    margin: 0.5rem auto 0 auto;
    line-height: 0.86rem;
    text-align: center;
    color: #fff;
    border-radius: 0.15rem;
    font-size: 0.3rem;
    font-weight: bold;
  }

  .bg-color-blue {
    background-color: #00c3f9 !important;
  }
  .google-bind {
    z-index: 1000;
    background-color: #fff;
    width: 350px;
    height: 370px;
    border-radius: 5px;
    /*border: #888888 2px solid;*/
    position: fixed;
    left: 50%;
    top: 50%;
    margin-top: -210px;
    margin-left: -175px;
    padding-top: 10px;
  }

  #forPop {
    z-index: 999;
    width: 100%;
    height: 1000px;
    top: 0px;
    left: 0px;
    position: absolute;
    /*因为IE不支持opacity 所以用filter 为了兼容两个都写*/
    filter: Alpha(opacity=60);
    opacity: 0.6;
    background: #000000;
  }
</style>
